import React from "react";
import { createContext, useContext, useState } from "react";

const GlobalContextClient = createContext({
  client: {},
  setClient: () => {},
});

export const ClientContextProvider = ({ children }) => {
  const [client, setClient] = useState({
    msisdn: "5511920066677",
    plan: "Alo 30",
    value: 3000,
  });
  return (
    <GlobalContextClient.Provider
      value={{
        client,
        setClient,
      }}
    >
      {children}
    </GlobalContextClient.Provider>
  );
};

export const useGlobalContextClient = () => useContext(GlobalContextClient);
